import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 18a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M17 6a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-1"}],["path",{"d":"M19 8v5a5 5 0 0 1 -5 5h-3l3 -3m0 6l-3 -3","key":"svg-2"}],["path",{"d":"M5 16v-5a5 5 0 0 1 5 -5h3l-3 -3m0 6l3 -3","key":"svg-3"}]]

const IconExchange = createReactComponent('outline', 'exchange', 'Exchange', __iconNode);

export default IconExchange;